import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import PrimaryButton from "../../elements/primary-button";
import { apiAsia } from "../../utils/api-asia";
import { mobileIs } from "../../utils/siteUtils";
import { gtag } from "../../utils";
import Videojs from "../video-js";
import "./style.scss";
const MediaKit = props => {
  const { rendering, fields, page } = props;
  const { title, buttonText, colorScheme, iconName, defaultCover, download_colorScheme, download_icon } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const [pageIndex, setPageIndex] = useState(1)
  let num = isMobile ? 8 : 12
  const [pageSize, setPageSize] = useState(num)
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0);
  const [showButton, setShowButton] = useState(false);

  const showMore = () => {
    gtag('event', 'Component_info', {
      'component_name': 'MediaKit',
      'page_title': page?.name
    });
    setPageIndex(pageIndex + 1)
    let size = pageSize * pageIndex;
    if (size > total || size === total) {
      setShowButton(false)
    }
  }

  const getList = async (pageIndex, pageSize) => {
    apiAsia.news.medialist({
      page: pageIndex,
      size: pageSize
    }).then(res => {
      if (!!res[0]) {
        let mediaslist = JSON.parse(JSON.stringify(list))
        if(res[0].DataList && res[0].DataList.length > 0) {
          res[0].DataList.forEach((item) => {
            item.size = item.Size / 1024 / 1024 > 0.1 ? (item.Size / 1024 / 1024).toFixed(1) + 'M' : (item.Size / 1024).toFixed(1) + 'KB'
            item.type = item.ContentType.indexOf('/') === -1 ? item.ContentType.toUpperCase() : (item.ContentType.substring(item.ContentType.lastIndexOf("/")+1)).toUpperCase()
            let type = (item.Name.substr(item.Name.lastIndexOf('.') + 1)).toLowerCase()
            if(type === 'mp4') {
              item.type = 'video'
            }
            if(type === 'png' || type === 'jpg' || type === 'svg' || type === 'jpeg' || type === 'gif') {
              item.type = 'image'
            }
            mediaslist.push(item)
          })
        }
        let size = pageSize * pageIndex;
        if (res[0].Total > size) {
          setShowButton(true)
        } else {
          setShowButton(false)
        }
        setTotal(res[0].Total)
        setList(mediaslist)
      }
    })
    .catch(err => {
      // 
    });
  };

  const downloadFile = (e, downloadUrl) => {
    gtag('event', 'Component_info', {
      'component_name': 'MediaKit',
      'page_title': page?.name
    });
    let a = document.createElement('a')
    a.setAttribute('download', 'download')
    a.setAttribute('href', downloadUrl.replace(/\+/g, "%2B"))
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const mouseOver = (e, index) => {
    let doms = document.querySelectorAll('.c-media-kit__content__item__image__animate')
    doms[index].style.transform = 'translateY(0)'
  }

  const mouseLeave = (e, index) => {
    let doms = document.querySelectorAll('.c-media-kit__content__item__image__animate')
    doms[index].style.transform = 'translateY(100%)'
  }

  useEffect(() => {
    getList(pageIndex, pageSize)
  }, [pageIndex, pageSize])

  const rootClasses = classNames("c-media-kit", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource}>
      <div className="c-media-kit__content">
        {list && list.length > 0 && list.map((item, index) => (
          <div className={["c-media-kit__content__item", index > 3 ? 'active' : ''].join(' ')} key={index} onMouseOver={(e) => (mouseOver(e, index))} onMouseLeave={(e) => (mouseLeave(e, index))}>
            <div className="c-media-kit__content__item__image">
              {item.type === 'image' && <img className="cover" src={item.CoverPic ? `${item.CoverPic}` : `${item.CdnUrl}`} />}
              {item.type !== 'video' && item.type !== 'image' && <div className="cover" style={{ backgroundImage: item.CoverPic ? `url(${item.CoverPic})` : `url(${defaultCover.value.src})` }}></div>}
              {item.type === 'video' && <Videojs {...{
                sources: [
                  {
                    src: item.CdnUrl,
                    type: item.ContentType
                  }
                ],
                autoplay: false,
                controls: false
              }} />}
              <div className="c-media-kit__content__item__image__animate">
                <div className="c-media-kit__content__item__image__animate__file">
                  {/*{item.type && item.type.length < 8 && <span className="c-media-kit__content__item__image__animate__file__type">{ item.type }</span>}*/}
                  <span className={["c-media-kit__content__item__image__animate__file__memory"].join(' ')}>{ item.size }</span>
                </div>
                <div className="c-media-kit__content__item__image__animate__operate" onClick={(e) => downloadFile(e, item.CdnUrl)}>
                  <PrimaryButton {...{
                    colorScheme: download_colorScheme,
                    iconName: download_icon
                  }} />
                </div>
              </div>
            </div>
            <div className="c-media-kit__content__item__botttom">
              <div className="c-media-kit__content__item__botttom__picture_name">{ item.Name }</div>
            </div>
          </div>
        ))}

        {showButton && <div className="load-more-content" onClick={showMore}>
          <PrimaryButton {...{
            buttonText: buttonText,
            colorScheme: colorScheme,
            iconName: iconName
          }} />
        </div>}
      </div>
    </div>
  );
};

export default  MediaKit;